import type { ApplyEmployeeDiscountResult } from '@spa/generated/graphql/graphql';
import { CustomOrderType } from '../../carts/CustomOrderType';
import { createAction } from '@reduxjs/toolkit';

export interface ApiAddEmployeeDiscountCodesRequestedPayload {
  readonly actionId: number;
  readonly customOrderType: CustomOrderType;
  readonly parentActionId: number;
}
export const apiAddEmployeeDiscountCodesRequestedType =
  'api/cart/addEmployeeDiscountCodes--requested';
export const apiAddEmployeeDiscountCodesRequested =
  createAction<ApiAddEmployeeDiscountCodesRequestedPayload>(
    apiAddEmployeeDiscountCodesRequestedType
  );
export type ApiAddEmployeeDiscountCodesRequestedAction = ReturnType<
  typeof apiAddEmployeeDiscountCodesRequested
>;

export interface ApiAddEmployeeDiscountCodesSucceededPayload {
  readonly cartId: string;
  readonly result: ApplyEmployeeDiscountResult;
  readonly requestedActionId: number;
  readonly parentActionId: number;
}
export const apiAddEmployeeDiscountCodesSucceededType =
  'api/cart/addEmployeeDiscountCodes--succeeded';
export const apiAddEmployeeDiscountCodesSucceeded =
  createAction<ApiAddEmployeeDiscountCodesSucceededPayload>(
    apiAddEmployeeDiscountCodesSucceededType
  );
export type ApiAddEmployeeDiscountCodesSucceededAction = ReturnType<
  typeof apiAddEmployeeDiscountCodesSucceeded
>;

export interface ApiAddEmployeeDiscountCodesFailedPayload {
  readonly requestedActionId: number;
  readonly parentActionId: number;
}
export const apiAddEmployeeDiscountCodesFailedType = 'api/cart/addEmployeeDiscountCodes--failed';
export const apiAddEmployeeDiscountCodesFailed =
  createAction<ApiAddEmployeeDiscountCodesFailedPayload>(apiAddEmployeeDiscountCodesFailedType);
export type ApiAddEmployeeDiscountCodesFailedAction = ReturnType<
  typeof apiAddEmployeeDiscountCodesFailed
>;
